import axios from "../services/api/api";

export const FETCH_SCHOOL_TEACHERS_BEGIN = "FETCH_SCHOOL_TEACHERS_BEGIN";
export const FETCH_SCHOOL_TEACHERS_FULFILLED =
  "FETCH_SCHOOL_TEACHERS_FULFILLED";
export const FETCH_SCHOOL_TEACHERS_REJECTED = "FETCH_SCHOOL_TEACHERS_REJECTED";

export const FETCH_SCHOOLS_BEGIN = "FETCH_SCHOOLS_BEGIN";
export const FETCH_SCHOOLS_FULFILLED = "FETCH_SCHOOLS_FULFILLED";
export const FETCH_SCHOOLS_REJECTED = "FETCH_SCHOOLS_REJECTED";

export function fetchSchoolTeachers(schoolId) {
  return dispatch => {
    dispatch({
      type: FETCH_SCHOOL_TEACHERS_BEGIN,
      payload: { loading: true }
    });
    return new Promise((resolve, reject) => {
      if (localStorage.getItem("email")) {
        axios
          .get("/GetTeachersBySchoolId?schoolId=" + schoolId)
          .then(response => {
            dispatch({
              type: FETCH_SCHOOL_TEACHERS_FULFILLED,
              payload: response.data.result
            });
            resolve(true);
          })
          .catch(err => {
            dispatch({ type: FETCH_SCHOOL_TEACHERS_REJECTED, payload: err });
            reject(err);
          });
      }
    });
  };
}

export function fetchSchoolsForAdmin() {
  return dispatch => {
    dispatch({
      type: FETCH_SCHOOLS_BEGIN,
      payload: { loading: true }
    });
    return new Promise((resolve, reject) => {
      if (localStorage.getItem("email")) {
        axios
          .get("/SchoolsForAdmin")
          .then(response => {
            dispatch({
              type: FETCH_SCHOOLS_FULFILLED,
              payload: response.data.result
            });
            resolve(true);
          })
          .catch(err => {
            dispatch({ type: FETCH_SCHOOLS_REJECTED, payload: err });
            reject(err);
          });
      }
    });
  };
}
